import { AxiosResponse } from "axios"
import { ValidationResultModel } from "components/models"
import {
  ClaimResponseApiModel,
  RoleDetailsApiModel,
  RoleDto,
  UpdateRoleAndClaimsRequest,
} from "components/pages/maintanance/roles/rolesDetails/roleDetailsModels"
import {
  AddSubTenantRole,
  CopySubTenantRole,
} from "components/pages/maintanance/SubTenantRoles"
import { RolesGridData } from "components/pages/maintanance/roles/rolesList/rolesList.models"
import EbateAxios from "queries/ebateAxios"
import { GenericApiResponseModel } from "components/models/common.model"
import { RolesUserData } from "components/pages/maintanance/workflow/workflowLevel/workflowLevelForm/WorkflowLevelForm.model"
import {
  AddRoleRequest,
  CopyRoleRequest,
} from "components/pages/maintanance/SubTenantRoles/subTenantRolesForm/subTenantRoleForm.models"

const subTenantRolesUrl = "/api/SubTenantRoles"

export const getSubTenantRoleClaims = async () => {
  const { AxiosGet } = EbateAxios()

  return AxiosGet<ClaimResponseApiModel[]>(
    `${subTenantRolesUrl}/GetSubTenantRoleClaims/`
  )
}

export const getSubTenantRoleDetails = async (id: string) => {
  const { AxiosGet } = EbateAxios()

  return AxiosGet<RoleDetailsApiModel>(
    `${subTenantRolesUrl}/GetSubTenantRoleDetails/${id}`
  )
}

export const getSubTenantRolesGridData = async (
  isPortal: boolean,
  subtenantCompanyId: number | undefined
) => {
  const url = `${subTenantRolesUrl}/GetSubTenantRolesGridData/${isPortal}/${subtenantCompanyId}`
  const { AxiosGet } = EbateAxios()

  return AxiosGet<RolesGridData>(url)
}

export const updateSubTenantRoleAndClaims = async (
  request: UpdateRoleAndClaimsRequest
): Promise<AxiosResponse<ValidationResultModel>> => {
  const url = `${subTenantRolesUrl}/UpdateSubTenantRoleAndClaims`
  const { AxiosPut } = EbateAxios()

  return AxiosPut<UpdateRoleAndClaimsRequest, ValidationResultModel>(
    url,
    request
  )
}

export const addSubTenantRole = async (data: AddRoleRequest) => {
  const url = `${subTenantRolesUrl}/AddSubTenantRole`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<AddRoleRequest, GenericApiResponseModel<RoleModel>>(
    url,
    data
  )
}
export const copySubTenantRole = async (data: CopyRoleRequest) => {
  const url = `${subTenantRolesUrl}/CopySubTenantRole`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<CopyRoleRequest, GenericApiResponseModel<RoleModel>>(
    url,
    data
  )
}

export const getNormalRoles = async (isPortal: boolean) => {
  const { AxiosGet } = EbateAxios()

  return AxiosGet<RoleDto[]>(`${subTenantRolesUrl}/GetNormalRoles/${isPortal}`)
}

export const getRolesAndUsers = async (isPortal) => {
  const { AxiosGet } = EbateAxios()
  return AxiosGet<RolesUserData[]>(
    `${subTenantRolesUrl}/GetRolesAndUsers/${isPortal}`
  )
}

export interface RoleModel {
  id: string
}
